// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2sga8","row":"Footer_row__3EE8Z","footerLogo":"Footer_footerLogo__2cp0i","socialIcons":"Footer_socialIcons__1KGwG"};